export default __webpack_public_path__ + "static/t-shirt-df99f5aaa037cb23990535b2ee1fafc2.jpg";